import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { AppCoreService } from "src/app/services/app-core.service";
import { GeoService } from "src/app/services/geo.service";
import { CompanyService } from "src/app/services/company.service";
import { EmailValidation, GSTValidation, PANValidation, REGNOValidation, MobileNumberValidation, UrlValidation, AlphaNumericValidation, TelephoneNumberValidation, regexPattern } from "src/app/models/validator";
import { FileHandlerService } from "src/app/services/file-handler.service";
import { HttpHeaders } from "@angular/common/http";
import { MiscService } from "src/app/services/misc/misc.service";
import { UserData } from "src/app/models/user.data-object";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Title } from "@angular/platform-browser";
import { NetworkService } from "src/app/services/network.service";
import { Utilities } from "src/app/models/utilities";

@Component({
    selector: 'app-add',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.scss']
})

export class AddCompanyComponent implements OnInit, AfterViewInit {
    companyId: number;
    companyForm: FormGroup;
    isFormSubmitted: boolean;
    permConfig = {
        isViewAllowed: false,
        isAddAllowed: false,
        isEditAllowed: false,
        isDeleteAllowed: false
    };
    isDefaultCompany = false;
    locationDetails: any;
    financialYearList: any[];
    countryList: any[] = [];
    stateList: any[] = [];
    cityList: any[] = [];
    selectOperationTypes: any[] = [];
    invoiceFormatList: any[];
    selectedCompanyLogoFile: File | null = null;
    companyLogoFileName = '';
    companyLogoFileURL = '';
    selectedSignatureFile: File | null = null;
    signatureFileName = '';
    signatureFileURL = '';
    showDefault = false;
    fyDateList = [];
    fyMonthList = [];
    billToList = ['Company', 'Service Center'];
    serviceCenterList: any[] = [];

    showLogoProgressBar = false;
    showsignatrueProgressBar = false;
    logoProgress: number = 0;
    signatrueProgress: number = 0;
    useEnterKey: any;
    selectedSCId: number;

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private companyService: CompanyService,
        private geoService: GeoService,
        private fileHandlerService: FileHandlerService,
        private appCoreService: AppCoreService,
        private miscService: MiscService,
        private ngxLoaderService: NgxUiLoaderService,
        private titleService: Title,
        private networkService: NetworkService,
        private utilities: Utilities,
    ) {
        titleService.setTitle('Companies');
    }


    ngOnInit(): void {
        this.fyDateList = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
            '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
        this.fyMonthList = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
        const userData: UserData = this.appCoreService.GetUserData();
        if (userData.accessType === 'System') {
            this.showDefault = true;
        }
        if (userData.metaInfo?.operationtype) {
            this.selectOperationTypes = userData.metaInfo?.operationtype;
        }
        this.companyForm = this.formBuilder.group({
            txtCode: [null, Validators.compose([Validators.required, Validators.maxLength(5)])],
            txtName: [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
            txtEmailId: [null, EmailValidation],
            ddlOperationType: [[this.selectOperationTypes[0]], Validators.compose([Validators.required])],
            ddlServiceCenters: ['', Validators.compose([Validators.required])],
            txtWebsite: [null, UrlValidation],
            txtGstNo: [null, GSTValidation],
            txtPanNo: [null, PANValidation],
            txtRegistrationNo: [null, REGNOValidation],
            txtBillingName: [null, Validators.maxLength(30)],
            ddlBillTo: ['Company', Validators.compose([Validators.required])],
            // ddlBillingState: [null, Validators.compose([Validators.required])],
            ddlInvoiceFormat: [null],
            txtStatus: [true],
            chkIsDefault: [false],
            companyLogoFileControl: [null],
            signatureFileControl: [null],
            // txtCompanyLogo: [null],
            // txtSignatoryLogo: [null],
            txtInvoiceFormat: [null],
            ddlFYDateFrom: ['01'],
            ddlFYMonthFrom: ['Jan'],
            ddlFYDateTo: ['31'],
            ddlFYMonthTo: ['Dec'],

            locationdetails: this.formBuilder.group({
                ddlCountry: [null, Validators.required],
                ddlState: [null, Validators.required],
                ddlCity: [null, Validators.required],
                txtPincode: [null],
                txtAddress1: [null, Validators.compose([Validators.required, Validators.maxLength(150)])],
                txtAddress2: [null, Validators.maxLength(150)],
                txtArea: [null, Validators.maxLength(30)],
                txtMobileNo: [null, Validators.compose([Validators.required, MobileNumberValidation])],
                txtTelephoneNo: [null, TelephoneNumberValidation],
            }),
            bankDetails: this.formBuilder.group({
                txtBankName: [],
                txtAccountNo: ['', Validators.pattern(/^\d{5,20}$/)],
                txtAccountName: [],
                txtBankAddress: [],
                txtIfscCode: [null, AlphaNumericValidation],
                txtMicr: [null, Validators.pattern(/^\d{9}$/)]
            }),
            terms: this.formBuilder.group({
                txtTerms: ''
            })
        });

        this.isFormSubmitted = false;

        this.checkPermission();
        if (this.permConfig.isAddAllowed) {
            this.appCoreService.SelectedServiceCenter().subscribe(val => {
                this.selectedSCId = val;
            });
            this.bindServiceCenterList();
            this.GetAllInvoiceFormats();
            this.companyForm.get('locationdetails.ddlState').valueChanges.subscribe(newState => {
                newState && this.applyGSTValidation();
            });
        }

    }

    getLocation(location?: any){
        this.stateList = location?.[0]?.state;
    }

    applyGSTValidation() {
        const docNoControl = this.companyForm.get('txtGstNo');
        const stateisocode = this.companyForm.get('locationdetails.ddlState')?.value;
        
        const taxCode = this.stateList?.find(row => row.isocode === stateisocode)?.taxcode;

        // Dynamically create the GSTIN regex pattern based on the state code
        const gstPattern = taxCode && `^(${taxCode})[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[0-9A-Z]{1}$`;

        // Now, update the regexPattern with the new dynamic pattern
        regexPattern.gstValidation = new RegExp(gstPattern);  // Update regex pattern
        docNoControl.setValidators([Validators.pattern(regexPattern.gstValidation)]);
        docNoControl.updateValueAndValidity();
    }

    ngAfterViewInit(): void {
        this.useEnterKey ? this.utilities.focusFirstElement(this.companyForm) : null;
    }

    checkPermission(): any {
        const userData = this.appCoreService.GetUserData();
        this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
        const permission = userData.config.filter(x => x.categoryname === 'Companies');
        if (permission.length) {
            this.permConfig.isViewAllowed = permission[0].view;
            this.permConfig.isAddAllowed = permission[0].add;
            this.permConfig.isEditAllowed = permission[0].edit;
            this.permConfig.isDeleteAllowed = permission[0].delete;
        }
    }

    GetAllInvoiceFormats() {
        try {
            this.miscService.GetAllInvoiceFormats().subscribe(res => {
                if (res?.success) {
                    this.invoiceFormatList = res.data;
                    // console.log(this.invoiceFormatList);
                    this.companyForm.controls.ddlInvoiceFormat.setValue(this.invoiceFormatList?.[0]?.id)
                }
            })
        } catch (error) {
        }
    }

    bindServiceCenterList() {
        try {
            this.ngxLoaderService.start();
            this.networkService.GetAllServiceCenters({ isactive: true }).subscribe((res: any) => {
                this.ngxLoaderService.stop();
                if (res && res.success) {

                    // bind accessible service center
                    this.serviceCenterList = res?.data.sort((a, b) => Number(a.disabled) - Number(b.disabled));
                    if (this.serviceCenterList && this.serviceCenterList.length > 0) {
                        // this.companyForm.get('ddlServiceCenters').setValue([this.serviceCenterList[0].id]);
                    }
                }
            });
        } catch (e) {
            console.error(e);
            this.ngxLoaderService.stop();
        }
    }

    onChangeFileSelect(evt, selectedType: string) {
        try {
            if (evt) {
                if (selectedType === 'CompanyLogo') {
                    this.selectedCompanyLogoFile = evt.target.files[0];
                } else if (selectedType === 'Signature') {
                    this.selectedSignatureFile = evt.target.files[0];
                }

            }
        } catch (e) {
            console.error(e);
        }
    }

    uploadFile(selectedType: string) {
        let interval: any;
        let timeout: any;
        try {
            if (selectedType === 'CompanyLogo') {
                if (this.selectedCompanyLogoFile) {
                    this.showLogoProgressBar = true;
                    this.logoProgress = 0;
                    interval = setInterval(() => {
                        if (this.logoProgress < 99) {
                            this.logoProgress += 1;
                        }
                    }, 100);
                    timeout = setTimeout(() => {
                        if (this.logoProgress >= 99 && this.logoProgress < 100) {
                            this.appCoreService.showMessage('Error in upload. Please try again later.', 'Error', 'error');
                            this.showLogoProgressBar = false;
                            clearInterval(interval);
                        }
                    }, 5000);
                    this.ngxLoaderService.start();
                    let requestObj = {
                        name: this.selectedCompanyLogoFile.name,
                        fileType: this.selectedCompanyLogoFile.type,
                        category: 'company'
                    };

                    this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe(res => {
                        try {
                            if (res && res.success) {
                                const signedUrl = res.data.uploadURL;
                                const fileId = res.data.fileId;
                                if (signedUrl) {
                                    let headers: HttpHeaders = new HttpHeaders({
                                        "Content-Type": requestObj.fileType
                                    });

                                    this.fileHandlerService.UploadFile(signedUrl, this.selectedCompanyLogoFile, headers).subscribe((f) => {
                                        if (f === null) {
                                            // console.log('F', f);
                                            this.fileHandlerService.UploadComplete({ id: fileId }).subscribe((res) => {
                                                if (res && res.success) {
                                                    this.ngxLoaderService.stop();
                                                    // console.log(res);
                                                    this.companyForm.get('companyLogoFileControl').setValue(fileId);
                                                    this.companyLogoFileName = res.data.name;
                                                    this.companyLogoFileURL = res.data.url;
                                                    this.logoProgress = 100;
                                                    clearInterval(interval);
                                                    clearTimeout(timeout);
                                                    setTimeout(() => {
                                                        this.showLogoProgressBar = false;
                                                    }, 1000);
                                                    this.ngxLoaderService.stop();
                                                }
                                            });
                                        }
                                    });
                                }
                            }
                        } catch (error) {
                            console.error(error);
                            this.ngxLoaderService.stop();
                        }
                    });
                } else {
                    this.ngxLoaderService.stop();
                    this.appCoreService.showMessage('Please select a file to upload', '', 'error');
                }

            } else if (selectedType === 'Signature') {
                if (this.selectedSignatureFile) {
                    this.showsignatrueProgressBar = true;
                    this.signatrueProgress = 0;
                    interval = setInterval(() => {
                        if (this.signatrueProgress < 99) {
                            this.signatrueProgress += 1;
                        }
                    }, 100);
                    timeout = setTimeout(() => {
                        if (this.signatrueProgress >= 99 && this.signatrueProgress < 100) {
                            this.appCoreService.showMessage('Error in upload. Please try again later.', 'Error', 'error');
                            this.showsignatrueProgressBar = false;
                            clearInterval(interval);
                        }
                    }, 5000);
                    this.ngxLoaderService.start();
                    let requestObj = {
                        name: this.selectedSignatureFile.name,
                        fileType: this.selectedSignatureFile.type,
                        category: 'company'
                    };

                    this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe(res => {
                        try {
                            if (res && res.success) {
                                const signedUrl = res.data.uploadURL;
                                const fileId = res.data.fileId;
                                if (signedUrl) {
                                    let headers: HttpHeaders = new HttpHeaders({
                                        "Content-Type": requestObj.fileType
                                    });
                                    this.fileHandlerService.UploadFile(signedUrl, this.selectedSignatureFile, headers).subscribe((f) => {
                                        if (f === null) {
                                            // console.log('F', f);
                                            this.fileHandlerService.UploadComplete({ id: fileId }).subscribe((res) => {
                                                if (res && res.success) {
                                                    // console.log(res);
                                                    this.companyForm.get('signatureFileControl').setValue(fileId);
                                                    this.signatureFileName = res.data.name;
                                                    this.signatureFileURL = res.data.url;
                                                    this.signatrueProgress = 100;
                                                    clearInterval(interval);
                                                    clearTimeout(timeout);
                                                    setTimeout(() => {
                                                        this.showsignatrueProgressBar = false;
                                                    }, 1000);
                                                    this.ngxLoaderService.stop();
                                                }
                                            });
                                        }
                                    });
                                }
                            }
                        } catch (error) {
                            this.ngxLoaderService.stop();
                            console.error(error);
                        }
                    });
                } else {
                    this.ngxLoaderService.stop();
                    this.appCoreService.showMessage('Please select a file to upload', '', 'error');
                }
            }

        } catch (e) {
            this.ngxLoaderService.stop();
            console.error(e);
        }
    }

    addCompany() {
        this.isFormSubmitted = true;
        let isCompanyLogoUploaded = false;
        const companyLogoFileId = this.companyForm.get('companyLogoFileControl')?.value || null;
        // if (this.selectedCompanyLogoFile && !companyLogoFileId) {
        //     this.appCoreService.showMessage('You have not uploaded company logo', '', 'warning');
        // }
        if (this.permConfig.isAddAllowed && this.companyForm.valid) {
            let companyArea = this.companyForm.get('locationdetails').get('txtArea')?.value;
            companyArea = (typeof companyArea === 'string') ? companyArea : companyArea?.area;
            let compPincode = this.companyForm.get('locationdetails').get('txtPincode').value
            compPincode = (typeof compPincode === 'string') ? compPincode : compPincode?.pincode;

            const requestObj = {
                code: this.companyForm.get('txtCode')?.value.toUpperCase(),
                name: this.companyForm.get('txtName')?.value,
                emailid: this.companyForm.get('txtEmailId')?.value,
                operationtype: this.companyForm.get('ddlOperationType')?.value,
                servicecenters: this.companyForm.get('ddlServiceCenters')?.value,

                website: this.companyForm.get('txtWebsite')?.value,
                gstno: this.companyForm.get('txtGstNo')?.value,
                panno: this.companyForm.get('txtPanNo')?.value,
                registrationno: this.companyForm.get('txtRegistrationNo')?.value,
                billingname: this.companyForm.get('txtBillingName')?.value,
                billto: this.companyForm.get('ddlBillTo')?.value,
                invoiceformatid: this.companyForm.get('ddlInvoiceFormat')?.value,
                logoid: this.companyForm.get('companyLogoFileControl')?.value,
                signaturelogoid: this.companyForm.get('signatureFileControl')?.value,
                isactive: this.companyForm.get('txtStatus')?.value,
                isdefault: this.companyForm.get('chkIsDefault').value,
                location: {
                    country: this.companyForm.get('locationdetails').get('ddlCountry').value,
                    state: this.companyForm.get('locationdetails').get('ddlState').value,
                    city: this.companyForm.get('locationdetails').get('ddlCity').value,
                    area: companyArea,
                    pincode: compPincode,
                    address1: this.companyForm.get('locationdetails').get('txtAddress1').value,
                    address2: this.companyForm.get('locationdetails').get('txtAddress2').value,
                    mobileno: this.companyForm.get('locationdetails').get('txtMobileNo').value,
                    tel: this.companyForm.get('locationdetails').get('txtTelephoneNo').value
                },
                bankdetails: {
                    bankName: this.companyForm.get('bankDetails').get('txtBankName')?.value,
                    accountNo: this.companyForm.get('bankDetails').get('txtAccountNo')?.value,
                    accountName: this.companyForm.get('bankDetails').get('txtAccountName')?.value,
                    bankAddress: this.companyForm.get('bankDetails').get('txtBankAddress')?.value,
                    ifsc: this.companyForm.get('bankDetails').get('txtIfscCode')?.value,
                    micr: this.companyForm.get('bankDetails').get('txtMicr')?.value,
                },
                terms: this.companyForm.get('terms').get('txtTerms')?.value
            }
            this.ngxLoaderService.start();
            this.companyService.Add(requestObj).subscribe((res) => {
                try {
                    if (res && res.success) {
                        this.ngxLoaderService.stop();
                        // console.log(res);
                        this.companyId = parseInt(res.data[0].id);
                        this.openSuccessDialog("Record Added Sucessfully");
                    } else if (res && !res.success && res?.data?.err_msg) {
                        this.ngxLoaderService.stop();
                        this.appCoreService.showMessage(res.data.err_msg, 'Error', 'error');
                    }
                }
                catch (err) {
                    this.ngxLoaderService.stop();
                    console.error(err);
                }
            })
        }
    }

    // financialYearfun(emittedList : any[]){
    //    this.financialYearList = emittedList;
    //    console.log('this.financialYearList',this.financialYearList);
    // }

    resetForm(): void {
        this.companyForm.reset();
        this.isFormSubmitted = false;
        this.companyForm.get('ddlBillTo').setValue('Customer');
    }

    back() {
        const companyLogo = this.companyForm.get('txtCompanyLogo')?.value;
        const signatoryLogo = this.companyForm.get('txtSignatoryLogo')?.value;
        const allowedTypes = ['jpg', 'jpeg', 'png', 'svg'];
        // if (companyLogo !== null) {
        //     const companyFileName = companyLogo.split('\\').pop();
        //     const companyType = companyFileName.split('.').pop().toLowerCase();
        //     if (companyLogo && !allowedTypes.includes(companyType)) {
        //         this.companyForm.get('txtCompanyLogo').setValue(null);
        //         this.companyLogoContent = '';
        //     }
        // }
        // if (signatoryLogo !== null) {
        //     const signatoryFileName = signatoryLogo.split('\\').pop();
        //     const signatoryType = signatoryFileName.split('.').pop().toLowerCase();
        //     if (signatoryLogo && !allowedTypes.includes(signatoryType)) {
        //         this.companyForm.get('txtSignatoryLogo').setValue(null);
        //         this.signatoryLogoContent = '';
        //     }
        // }
    }

    async openSuccessDialog(msg: any) {
        const result = await Swal.fire({
            // title: 'Success!',
            text: msg,
            icon: 'success',
            confirmButtonText: 'OK',
            allowEscapeKey: false,
            allowOutsideClick: false
        })
        if (result.isConfirmed) {
            this.router.navigate(['/setup/companies']);
        }
    }

    async openErrorDialog(msg: any) {
        const result = await Swal.fire({
            title: 'Error!',
            text: msg,
            icon: 'error',
            confirmButtonText: 'OK',
            allowEscapeKey: false,
            allowOutsideClick: false
        })
        if (result.isConfirmed) {
            // this.back();
        }
    }

    blockFormSubmit() {
        return false;
    }

    redirectToNewWindow() {
        const websiteUrl = this.companyForm.get('txtWebsite')?.value;
        if (websiteUrl) {
            const hasProtocol = websiteUrl.startsWith('http://') || websiteUrl.startsWith('https://');
            const urlToOpen = hasProtocol ? websiteUrl : `http://${websiteUrl}`;
            window.open(urlToOpen, '_blank');
        }
    }

}